export default {
    fields:[
        {
            key: "headerName",
            label:"name",
            sorter: false,
            filter: false,
            
        },
        {
            key: "headerValue",
            label:"value",
            sorter: false,
            filter: false,
        },
        {
            key: "options",
            label:"options",
            sorter: false,
            filter: false,
            _style: 'width:10%',
            _classes: "text-center" 
        },
    ],
    items:[]
}